import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import Noticias from "Projects/HAPK_hapkiapp_project/Components/Noticias/Noticias";

import {
  MDBCol,
  MDBContainer,
  MDBRow
} from "mdb-react-ui-kit";

import Eventos from "../Eventos/Eventos";

import { Slider } from "Projects/HAPK_hapkiapp_project/Components/Slider/Slider";

const Home = ({ onLoading }) => {
  const [noticias, setNoticias] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isLoggedIn, setisLoggedIn] = useState(false);

  useEffect(() => {
    getNoticias();
  }, []);

  const getNoticias = () => {
    onLoading(true);

    doFetch("HAPK", "getAllNews", null)
      .then((response) => response.json())
      .then((data) => {
        console.log(JSON.stringify(data, null, 2));
        setNoticias(data.DATA);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", JSON.stringify(error, null, 2));
      })
      .finally(() => {
        onLoading(false);
      });
  };

  return (
    <div>
      <Slider></Slider>
      <MDBContainer>
        <MDBRow className="mt-3">
          <MDBCol size="9">
            <h2 className="text-center text-hapkido">NOTICIAS</h2>
            <Noticias onLoading={setLoading} />
          </MDBCol>
          <MDBCol size="3">
            <div>
              <h2 className="text-center text-hapkido2">EVENTOS</h2>
              <Eventos onLoading={setLoading}></Eventos>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
};

export default Home;
